
import Vue from 'vue';
import { requestJapi } from '@/util/api';
import { Component } from 'vue-property-decorator';

@Component({})
export default class LoginPage extends Vue {
  username: string = '';
  userpwd: string = '';
  openid: string = '';

  mounted(): void {
    if (location.href.split('?authdata=')[1]) {
      const us = JSON.parse(decodeURIComponent(location.href.split('?authdata=')[1].split('#')[0]));
      this.openid = us.openid;
    }
  }

  async login(): Promise<void> {
    const params = {
      username: this.username,
      password: this.userpwd,
      openid: this.openid,
    };

    const res = await requestJapi<{
      token: string;
      user: {
        role: {
          name: string;
          menus: Array<{
            sub: Array<{ url: string }>;
            url: string;
          }>;
        };
      };
    }>('japi/user/login', params, 'POST');
    if (res.code !== 200) {
      this.$message.error(res.message);
      return;
    }

    this.$message.success(res.message);
    const userinfo = res.data;
    localStorage.setItem('userinfo', JSON.stringify(userinfo.user));

    localStorage.setItem('token', userinfo.token);
    if (userinfo.user.role.name === '学生' && window.innerWidth < 1000) {
      this.$router.push('/stumobile');
    } else {
      const scheduleMenu =
        userinfo.user.role.menus.find((menu) => menu.url.includes('module/syllabus.php')) ||
        userinfo.user.role.menus[0];

      const url = scheduleMenu.sub ? scheduleMenu.sub[0].url.split('/')[1] : scheduleMenu.url.split('/')[1];
      this.$router.push('/' + url.substr(0, url.indexOf('.')));
    }
  }
}
